import { render } from "./App.vue?vue&type=template&id=4a175a28"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./style.css?vue&type=style&index=0&lang=css"

import exportComponent from "/Users/maikejun/Desktop/code/dk/preSaleNew/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__